import React from "react";


const MobilePhoneIcon: React.FC<{ h?: number }> = ({h = 17}) => <svg width={h} height={h} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 36C11 36 7 36 7 32V4C7 4 7 0 11 0H25C25 0 29 0 29 4V32C29 32 29 36 25 36H11Z" fill="#31373D"/>
    <path d="M9 5H27V31H9V5Z" fill="#55ACEE"/>
  </svg>
;

export {MobilePhoneIcon};